var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookfillable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15080_236201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53101 20.892V11.1576H0.957031V7.65276H3.53101V4.65916C3.53101 2.30676 5.05148 0.146484 8.55494 0.146484C9.97344 0.146484 11.0224 0.282471 11.0224 0.282471L10.9397 3.55541C10.9397 3.55541 9.86998 3.545 8.70265 3.545C7.43925 3.545 7.23683 4.12722 7.23683 5.09357V7.65276H11.0401L10.8746 11.1576H7.23683V20.892H3.53101",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15080_236201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.0831,
    height: 20.7455,
    fill: "inherit",
    transform: "translate(0.957031 0.146484)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookfillable);
export default __webpack_public_path__ + "static/media/facebookfillable.f45d51d5c65374fd64ab6f75877b1100.svg";
export { ForwardRef as ReactComponent };